import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { generateMnemonic, EthHdWallet } from 'eth-hd-wallet'
import LoginService from '@/services/LoginService.js'
import aes256 from 'aes256'
import VuexPersistence from 'vuex-persist'
const ahtTransactions = require('../lib/ahtTransaction.js')

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)

function surveyInitialData () {
  const data = {
    how_pandemic_affected_work: null,
    how_pandemic_affected_mental_health: null,
    how_pandemic_affected_social_life_friendship: null,
    how_pandemic_affected_finances: null,
    how_pandemic_affected_lost_anybody: null,
    how_pandemic_affected_physical_health: null,
    how_pandemic_affected_not_at_all: null,
    have_an_existing_chronic_condition: null,
    chronic_conditions: null,
    catch_covid: null,
    taken_any_preventative_health_precautions: null,
    risk_of_getting_virus_been_source_of_stress: null,
    worry_about_risk_factor_after_vaccine: null,
    highest_level_of_education: null,
    race_ethnicity: null,
    info_race_ethnicity: null,
    average_household_income: null,
    would_you_get_treatment: null,
    concerned_about_vaccination_or_treatment: null,
    why_concerned: null,
    which_treatment_open_to_getting: null
  }
  return data
}

function getRandomString (length) {
  let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length))
  }
  return result
}

function orderByAgeRange (data) {
  const rangeOrder = {
    '18 - 29': 0,
    '30 - 39': 1,
    '40 - 49': 2,
    '50 - 59': 3,
    '60 - 69': 4,
    '70 - 79': 5,
    'Over 80': 6
  }

  data.sort((a, b) => rangeOrder[a.range] - rangeOrder[b.range])

  return data
}

export default new Vuex.Store({
  state: {
    lastPage: '',
    data: surveyInitialData(),
    address: '',
    publicKey: '',
    privateKey: '',
    surveyComplete: null,
    countryCode: 'MX',
    registerInformation: {
      gender: '',
      birthDate: '',
      height: '',
      heightMetric: '',
      weight: '',
      weightMetric: '',
      nickname: 'anonymous'
    },
    haveYouCaughtCovid: [],
    participantsByAge: [],
    participantsByGender: [],
    participantsByLocation: [],
    treatment: [],
    whyConcerned: [],
    wouldTakeTreatment: []
  },
  mutations: {
    SET_AUTHORIZATION (state, userData) {
      window.localStorage.setItem('x-auth-token', `Bearer ${
        userData
      }`)

      LoginService.updateToken()

      axios.defaults.headers.common['x-auth-token'] = `Bearer ${
        userData
      }`
    },
    SET_REGISTER_INFORMATION (state, value) {
      value.forEach(item => {
        state.registerInformation[item.key] = item.data
      })
    },
    SET_DATA_SURVEY (state, data) {
      state.data[data.key] = data.value
    },
    SET_SURVEY_STATUS (state, status) {
      let object = {
        'status': status
      }

      window.localStorage.setItem('survey-complete', JSON.stringify(object))

      state.page = ''
      state.surveyComplete = status
    },
    SET_ACCOUNT (state, account) {
      state.address = account.address
      state.publicKey = account.publicKey
      state.privateKey = account.privateKey
      window.localStorage.setItem('credentials', JSON.stringify(account))
    },
    SET_COUNTRY_CODE (state, code) {
      state.countryCode = code
    },
    async SET_STATS (state, data) {
      state.haveYouCaughtCovid = data.HaveYouCaughtCovid
      state.participantsByAge = await orderByAgeRange(data.ParticipantsByAge)
      state.participantsByGender = data.ParticipantsByGender
      state.participantsByLocation = data.ParticipantsByLocation
      state.treatment = data.Treatment
      state.whyConcerned = data.WhyConcerned
      state.wouldTakeTreatment = data.WouldTakeTreatment
    },
    SET_LAST_PAGE (state, page) {
      let object = {
        'page': page
      }

      window.localStorage.setItem('last-page', JSON.stringify(object))

      state.lastPage = page
    }
  },
  actions: {
    saveAnswer ({ commit }, answer) {
      commit('SET_DATA_SURVEY', answer)
    },
    generateWords ({ commit }) {
      const mnemonic = generateMnemonic()

      const wallet = EthHdWallet.fromMnemonic(mnemonic)

      wallet.generateAddresses(1)

      const account = {
        address: '0x' + wallet._children[0].wallet.getAddress().toString('hex'),
        publicKey: '0x' + wallet._children[0].wallet.getPublicKey().toString('hex'),
        privateKey: wallet._children[0].wallet.getPrivateKey().toString('hex')
      }

      commit('SET_ACCOUNT', account)
    },
    async register ({ state }) {
      let deviceData = {
        address: state.address,
        device: '',
        lang: state.countryCode,
        uuid: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        hash: await getRandomString(64)
      }

      await LoginService.addDevice(deviceData).then()

      let user = {
        address: state.address,
        gender: state.registerInformation.gender,
        birthDate: new Date(state.registerInformation.birthDate * 1000),
        height: state.registerInformation.height,
        heightMetric: state.registerInformation.heightMetric,
        weight: state.registerInformation.weight,
        weightMetric: state.registerInformation.weightMetric,
        nickname: state.registerInformation.nickname,
        countryCode: state.countryCode
      }

      return LoginService.register(user).then()
    },
    getLocation ({ commit }) {
      return LoginService.getLocationInfo()
        .then(({ data }) => {
          if (data) {
            commit('SET_COUNTRY_CODE', data.country_code)
          }
        })
    },
    async saveSurvey ({ commit, state }) {
      let gameAbiAddress = process.env.VUE_APP_GAME_ABI
      let credentials = JSON.parse(window.localStorage.getItem('credentials'))
      let txData = ''

      let covidVaccineSurvey = {
        data: aes256.encrypt(credentials.privateKey, JSON.stringify(state.data))
      }

      let hashSurvey = await LoginService.addHealthData(covidVaccineSurvey)

      let survey = {
        address: credentials.address,
        type: 'COVID19_Vaccine_Survey',
        data: state.data
      }

      try {
        txData = await ahtTransactions.saveHash({
          'type': 'COVID19_Vaccine_Survey',
          'contractAddress': gameAbiAddress,
          'address': credentials.address,
          'chainId': Number(process.env.VUE_APP_CHAIN_ID),
          'privateKey': credentials.privateKey,
          'hash1': hashSurvey.data.hash1,
          'hash2': hashSurvey.data.hash2
        })
        survey.txHash = txData

        return LoginService.saveSurvey(survey)
          .then(({ data }) => {
            commit('SET_SURVEY_STATUS', true)
          })
      } catch (error) {
        throw error
      }
    },
    async getCOVID19VaccineStats ({ commit }) {
      return LoginService.getCOVID19VaccineStats()
        .then(({ data }) => {
          commit('SET_STATS', data)
        })
    }
  },
  getters: {
    SurveyComplete: state => {
      if (state.surveyComplete === null) {
        let surveyComplete = window.localStorage.getItem('survey-complete')

        if (surveyComplete) {
          let data = JSON.parse(surveyComplete)

          state.surveyComplete = data.status
        } else {
          state.surveyComplete = false
        }
      }

      return state.surveyComplete
    },
    getHaveYouCaughtCovid: state => {
      return state.haveYouCaughtCovid
    },
    getParticipantsByAge: state => {
      return state.participantsByAge
    },
    getParticipantsByGender: state => {
      return state.participantsByGender
    },
    getParticipantsByLocation: state => {
      return state.participantsByLocation
    },
    getTreatment: state => {
      return state.treatment
    },
    getWhyConcerned: state => {
      return state.whyConcerned
    },
    getWouldTakeTreatment: state => {
      return state.wouldTakeTreatment
    },
    getLastPage: state => {
      return state.lastPage
    },
    getHasCovid: state => {
      return state.data.catch_covid
    }
  },
  plugins: [vuexLocal.plugin]
})
